import { useQuery } from "@tanstack/react-query";
import { defineChain } from "../../../../../../../chains/utils.js";
import { getPaySupportedDestinations, getPaySupportedSources, } from "../../../../../../../pay/utils/definitions.js";
import { getClientFetch } from "../../../../../../../utils/fetch.js";
import { withCache } from "../../../../../../../utils/promise/withCache.js";
async function fetchBuySupportedDestinations(client, isTestMode) {
    return withCache(async () => {
        const fetchWithHeaders = getClientFetch(client);
        const res = await fetchWithHeaders(`${getPaySupportedDestinations()}?isTestMode=${isTestMode}`);
        const data = (await res.json());
        return data.result.map((item) => ({
            chain: defineChain({
                id: item.chainId,
            }),
            tokens: item.tokens,
        }));
    }, {
        cacheKey: "destination-tokens",
        cacheTime: 5 * 60 * 1000,
    });
}
/**
 * @internal
 */
export function useBuySupportedDestinations(client, isTestMode) {
    return useQuery({
        queryKey: ["destination-tokens", client],
        queryFn: async () => {
            return fetchBuySupportedDestinations(client, isTestMode);
        },
    });
}
export function useBuySupportedSources(options) {
    return useQuery({
        queryKey: ["source-tokens", options],
        queryFn: async () => {
            const fetchWithHeaders = getClientFetch(options.client);
            const baseUrl = getPaySupportedSources();
            const url = new URL(baseUrl);
            url.searchParams.append("destinationChainId", options.destinationChainId.toString());
            url.searchParams.append("destinationTokenAddress", options.destinationTokenAddress);
            const res = await fetchWithHeaders(url.toString());
            const data = (await res.json());
            return data.result.map((item) => ({
                chain: defineChain({
                    id: item.chainId,
                }),
                tokens: item.tokens,
            }));
        },
    });
}
//# sourceMappingURL=useSwapSupportedChains.js.map